import styled from 'react-emotion';
import { Link } from 'react-router-dom';

export const People = styled.div`
	margin-bottom: 2.5rem;
`;

export const List = styled.ul`
	list-style-type: none;
	margin: 0;
	padding: 0;
`;

export const Item = styled.li`
	display: flex;
	font-size: 0.875rem;
	font-weight: 300;
	line-height: 1.5;
	padding: 0.5rem 0;

	&:nth-child(even) {
		background: #f2f2f2;
	}

	&:nth-child(odd) {
		background: #fff;
	}

	span,
	a {
		box-sizing: border-box;
		padding: 0 0.5rem;
	}

	@media (max-width: 480px) {
		font-size: 0.8125rem;
		flex-wrap: wrap;
	}
`;

export const Name = styled.span`
	flex: 0 0 40%;

	@media (max-width: 480px) {
		flex-basis: 100%;
		margin-bottom: 0.25rem;
	}
`;

export const Party = styled.span`
	flex: 0 0 20%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	@media (max-width: 480px) {
		flex-basis: 50%;
	}
`;

export const Area = styled(Link)`
	flex: 0 0 30%;
	text-align: right;

	@media (max-width: 480px) {
		flex: 1 0 auto;
	}
`;

export const Percent = styled.span`
	flex: 0 0 20%;
	text-align: right;

	@media (max-width: 480px) {
		flex: 1 0 auto;
	}
`;

export const Votes = styled.span`
	flex: 1;
	text-align: right;
		@media (max-width: 480px) {
			flex: 1 0 auto;
	}
`
